import { Alert, Card } from "flowbite-react";
import React from "react";
import TitleStripe from "../../common/TitleStripe";
import NoOcurrence from "../../common/query/NoOcurrence";
import PendenciasFinanceiras from "../../common/query/PendenciasFinanceiras";
import {
  countDadosCadastrais,
  formatDocument,
  getColorScore,
  getImageURLScore,
  getImageURLScoreSerasa,
} from "../../../utils/utils";
import Protestos from "../../common/query/Protestos";
import ChequesSemFundos from "../../common/query/ChequesSemFundos";
import HistoricoConsultas from "../../common/query/HistoricoConsultas";

const DividasQuery = ({ data, dataFull }) => {
  const score = data?.score?.score;
  const inadimplencia = data?.score?.probabilidadeInadimplencia;

  const totalDadosCadastrais = Array.isArray(dataFull)
    ? dataFull.reduce((acc, item) => acc + countDadosCadastrais(item), 0)
    : countDadosCadastrais(dataFull);

  // Só renderiza se houver exatamente 1
  const podeRenderizarDadosCadastrais = totalDadosCadastrais === 1;

  return (
    <div className="flex flex-col gap-6">
      {data?.statusRetorno === 1 ? (
        <>
          {data?.dadosCadastrais && podeRenderizarDadosCadastrais && (
            <div>
              <TitleStripe>Dados Cadastrais</TitleStripe>
              <div className="grid grid-cols-2 gap-6 mt-3">
                <div className="p-4 bg-gray-50 rounded-lg  space-y-4">
                  <div>
                    <span className="block text-sm text-gray-500">
                      {data?.dadosCadastrais?.cpf
                        ? "Nome Completo"
                        : "Razão Social"}
                    </span>
                    <span className="font-semibold">
                      {data?.dadosCadastrais?.nome ||
                        data?.dadosCadastrais?.razaoSocial ||
                        "Indisponível"}
                    </span>
                  </div>
                  <div>
                    <span className="block text-sm text-gray-500">
                      {data?.dadosCadastrais?.cpf
                        ? "Nome da Mãe"
                        : "Ramo de atividade"}
                    </span>
                    <span className="font-semibold">
                      {data?.dadosCadastrais?.nomeMae ||
                        data?.dadosCadastrais?.ramoAtividade ||
                        "Indisponível"}
                    </span>
                  </div>
                  <div>
                    <span className="block text-sm text-gray-500">
                      Data de{" "}
                      {data?.dadosCadastrais?.cpf ? "Nascimento" : "Fundação"}
                    </span>
                    <span className="font-semibold">
                      {data?.dadosCadastrais?.dataNascimento ||
                        data?.dadosCadastrais?.dataFundacao ||
                        "Indisponível"}
                    </span>
                  </div>
                </div>

                <div className="p-4 bg-gray-50 rounded-lg  space-y-4">
                  <div>
                    <span className="block text-sm text-gray-500">
                      {data?.dadosCadastrais?.cpf ? "CPF" : "CNPJ"}
                    </span>
                    <span className="font-semibold">
                      {formatDocument(
                        data?.dadosCadastrais?.cpf ||
                          data?.dadosCadastrais?.cnpj
                      ) || "Indisponível"}
                    </span>
                  </div>
                  <div>
                    <span className="block text-sm text-gray-500">
                      Situação do {data?.dadosCadastrais?.cpf ? "CPF" : "CNPJ"}
                    </span>
                    <span
                      className={`font-semibold px-2 py-1 rounded-md text-white text-sm w-fit ${
                        data?.dadosCadastrais?.situacao?.toUpperCase() ===
                          "REGULAR" ||
                        data?.dadosCadastrais?.situacao?.toUpperCase() ===
                          "ATIVA"
                          ? "bg-green-500"
                          : "bg-red-500"
                      }`}
                    >
                      {data?.dadosCadastrais?.situacao || "Indisponível"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* SCORE */}
          <div>
            <TitleStripe>Score</TitleStripe>

            <div className="grid grid-cols-2 gap-6 mt-4">
              {/* Card do Score com imagem e número */}
              <div className="flex flex-col items-center justify-center border rounded-xl bg-white shadow-sm p-6">
                <img
                  src={getImageURLScoreSerasa(score)}
                  alt="Score"
                  className="h-24"
                />
                <div
                  className="font-bold text-base text-white mt-4 px-6 py-2 rounded-full shadow"
                  style={{ backgroundColor: getColorScore(score) }}
                >
                  Score {score ?? "Não disponível"}
                </div>
              </div>

              {/* Card da Probabilidade */}
              <div className="flex items-center border border-gray-200 rounded-xl bg-gray-50 p-6 shadow-sm">
                <div className="text-gray-800 text-base">
                  <p className="font-medium">Probabilidade de inadimplência:</p>
                  <p className="text-4xl font-bold text-red-600 mt-1">
                    {inadimplencia != null ? `${inadimplencia}%` : "N/A"}
                  </p>
                  <p className="text-sm text-gray-600 mt-2">
                    Esta métrica indica a chance estimada de que o cliente deixe
                    de cumprir com suas obrigações financeiras nos próximos 12
                    meses. Quanto maior o percentual, maior o risco associado à
                    concessão de crédito.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <TitleStripe className="mb-4">Pendências Financeiras</TitleStripe>
            {data?.pendenciasFinanceiras?.length > 0 ? (
              <PendenciasFinanceiras
                pendenciasFinanceiras={data.pendenciasFinanceiras}
                quantidadeTotal={
                  data?.resumoConsulta?.pendenciasFinanceiras?.quantidadeTotal
                }
                valorTotal={
                  data?.resumoConsulta?.pendenciasFinanceiras?.valorTotal
                }
              />
            ) : (
              <NoOcurrence />
            )}
          </div>
          <div>
            <TitleStripe className="mb-4">Protestos</TitleStripe>
            {data?.protestos?.length > 0 ? (
              <Protestos
                quantidadeTotal={
                  data?.resumoConsulta?.protestos?.quantidadeTotal
                }
                valorTotal={data?.resumoConsulta?.protestos?.valorTotal}
                protestos={data.protestos}
                temVencimento={false}
              />
            ) : (
              <NoOcurrence />
            )}
          </div>
          <div>
            {/* CHEQUES SEM FUNDO */}
            <TitleStripe className="mb-4">Cheques Sem Fundo</TitleStripe>
            {data?.chequesSemFundo?.length > 0 ? (
              <ChequesSemFundos
                quantidadeTotal={
                  data?.resumoConsulta?.chequesSemFundo?.quantidadeTotal
                }
                chequesSemFundos={data.chequesSemFundo}
              />
            ) : (
              <NoOcurrence />
            )}
          </div>
          {data?.historicoConsultas && (
            <div>
              <TitleStripe>Histórico de consultas</TitleStripe>

              {data?.historicoConsultas?.length > 0 ? (
                <div className="flex gap-2 items-start">
                  <div className="flex-1">
                    <HistoricoConsultas
                      historicoConsultas={data?.historicoConsultas}
                    />
                  </div>
                  {/* {data?.historicoConsultasResumo?.paresMesAnoHistoricoConsultas
              ?.length > 0 && (
              <ReactApexChart
                className="border border-gray-200 rounded-md w-2/5 mt-3"
                options={{
                  colors: ["var(--primary)"],
                  chart: {
                    height: 150,
                    type: "bar",
                    toolbar: {
                      show: false, // Remove o menu de ações
                    },
                  },
                  plotOptions: {
                    bar: {
                      borderRadius: 2,
                      dataLabels: {
                        position: "center", // top, center, bottom
                      },
                    },
                  },
                  dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                      return val;
                    },
                    offsetY: 0,
                    style: {
                      fontSize: "12px",
                      colors: ["white"],
                    },
                  },

                  xaxis: {
                    categories:
                      data?.historicoConsultasResumo
                        ?.paresMesAnoHistoricoConsultas,
                    position: "top",
                    axisBorder: {
                      show: false,
                    },
                    axisTicks: {
                      show: false,
                    },
                    crosshairs: {
                      fill: {
                        type: "gradient",
                        gradient: {
                          colorFrom: "#30ce2d",
                          colorTo: "#30ce2d",
                          stops: [0, 100],
                          opacityFrom: 0.4,
                          opacityTo: 0.5,
                        },
                      },
                    },
                    tooltip: {
                      enabled: true,
                    },
                  },
                  yaxis: {
                    axisBorder: {
                      show: false,
                    },
                    axisTicks: {
                      show: false,
                    },
                    labels: {
                      show: false,
                      formatter: function (val) {
                        return val;
                      },
                    },
                  },
                  title: {
                    text: "Últimos 90 dias",
                    floating: true,
                    offsetY: 155,
                    align: "center",
                    style: {
                      color: "#444",
                    },
                  },
                }}
                series={[
                  {
                    name: "Qtd. Consultas no período",
                    data: data?.historicoConsultasResumo
                      ?.totaisHistoricoConsultas,
                  },
                ]}
                type="bar"
                height={175}
              />
            )} */}
                </div>
              ) : (
                <NoOcurrence />
              )}
            </div>
          )}
        </>
      ) : (
        <Alert withBorderAccent color="gray">
          Consulta indisponível no momento.
        </Alert>
      )}
    </div>
  );
};

export default DividasQuery;
